import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { sceneSlice } from '../../../store/reducers/SceneReducer';
import { Potion } from '../../../mechanics/items/Potion';
import './ChestScene.scss'
import chest from '../../../assets/img/Chest2.png'
import chestWebp from '../../../assets/img/Chest2.webp'
import potion from '../../../assets/img/potions/potion.png'
import potionWebp from '../../../assets/img/potions/potion.webp'
import goldIcon from '../../../assets/img/inventory/coin2.png'
import goldIconWebp from '../../../assets/img/inventory/coin2.webp'
import ImgWithFallback from '../../ui/ImgWithFallback';


const ChestScene = () => {
    //redux const
    const dispath = useAppDispatch()
    const characterInventory = useAppSelector(state => state.userReducer.character.getInventory())
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const locationsController = useAppSelector(state => state.SceneReducer.locations)
    const currentLocationIndex = useAppSelector(state => state.SceneReducer.currentLocation)
    const { setScene } = sceneSlice.actions
    //useState const
    const [isLootGetted, setIsLootGetted] = useState(false)
    const [loot, setLoot] = useState<number | Potion>(0)

    useEffect(() => {
        if (typeof loot === "number")
            mainCharacter.addGold(loot)
        else
            characterInventory.pushInInventory(loot)
    }, [isLootGetted])

    const getLoot = () => {
        setLoot(locationsController.getLocationsSet()[currentLocationIndex].getLoot())
        setIsLootGetted(true)
    }

    const nextLocation = () => {
        dispath(setScene("explore"))
    }

    return (
        <div className='chest-scene'>
            <div className="chest-scene__bimg">
                <ImgWithFallback
                    src={locationsController.getLocationsSet()[currentLocationIndex].getBackground().webp}
                    fallbackSrc={locationsController.getLocationsSet()[currentLocationIndex].getBackground().img} />
            </div>
            <div className="chest-scene__wrapper">
                <div className="chest-scene__content">
                    {!isLootGetted && <div className="chest-scene__cimg">
                        <ImgWithFallback src={chestWebp} fallbackSrc={chest} onClick={getLoot} />
                    </div>}
                    {isLootGetted && <div className="chest-scene__loot" onClick={nextLocation}>
                        <p>Yors loot is:</p>
                        {
                            typeof loot === "number" ?
                                <div className="chest-scene__loot-content gold">
                                    <ImgWithFallback src={goldIconWebp} fallbackSrc={goldIcon} />
                                    <span>{loot}</span>
                                </div>
                                :
                                <div className="chest-scene__loot-content">
                                    <ImgWithFallback src={potionWebp} fallbackSrc={potion} />
                                </div>
                        }
                        <p>Click to go</p>
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default ChestScene;